
import React, {FC, useState} from 'react';
import classNames from 'classnames';
import {useContextConfig} from 'pages/pricing-packages/components/context';

import {TabProps} from './Tab';

import * as styles from './styles.module.scss';

type TabsProps = {
	mobile?: boolean,
	desktop?: boolean,
	default?: string,
	children: (React.ReactElement<TabProps> | null)[],
}

const Tabs: FC<TabsProps> = (props) => {
	const config = useContextConfig();
	const [selected, setSelected] = useState<React.Key>(props.default || '');

	// Automatically map in "selected" and "onSelect"
	const headings = React.Children.map(props.children, (child, index) => {
		if (!child) {
			return null;
		}
		return React.cloneElement(child.props.children[0], {
			selected: selected ? selected === child.key : index === 0,
			onSelect: () => setSelected(`${child.key}`),
		});
	});

	// Clone if an element is selected; default false
	const contents = React.Children.map(props.children, (child, index) => {
		if (!child) {
			return null;
		}
		const isSelected = selected ? selected === child.key : index === 0;
		if (isSelected) {
			return React.cloneElement(child.props.children[1], {
				selected: true,
			});
		}
		return child.props.children[1];
	});

	return (
		<div className={classNames({
			[styles.mobile]: props.mobile,
			[styles.desktop]: props.desktop,
			[styles.modal]: config.modal,
		})}>
			<div className={classNames({
				[styles.headings]: true,
				[styles.modal]: config.modal,
			})}>
				{headings}
			</div>
			<div className={classNames({
				[styles.contents]: true,
				[styles.modal]: config.modal,
			})}>
				{contents}
			</div>
		</div>
	);
};

export default Tabs;
